var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model',{staticClass:"tick-model",on:{"clickHandler":_vm.exit}},[_c('img',{staticClass:"fail btn",attrs:{"src":require("@img/fail.png")},on:{"click":_vm.exit}})])}
var staticRenderFns = []

export { render, staticRenderFns }